import { toast, type ToastT, type ExternalToast } from 'sonner'
import type { MouseEvent } from 'react'

export function useToast() {
    const showToast = (message: string, type: 'success' | 'error' | 'info' | 'warning', options?: ExternalToast) => {
        const toastFn = {
            success: toast.success,
            error: toast.error,
            info: toast.info,
            warning: toast.warning,
        }[type]

        return toastFn(message, options)
    }

    const success = (message: string, options?: ExternalToast) => {
        return showToast(message, 'success', options)
    }

    const error = (message: string, options?: ExternalToast) => {
        return showToast(message, 'error', options)
    }

    const info = (message: string, options?: ExternalToast) => {
        return showToast(message, 'info', options)
    }

    const warning = (message: string, options?: ExternalToast) => {
        return showToast(message, 'warning', options)
    }

    const promise = <T>(
        promise: Promise<T>,
        {
            loading = 'Loading...',
            success = 'Success!',
            error = 'Something went wrong',
        }: {
            loading?: string
            success?: string | ((data: T) => string)
            error?: string | ((error: Error) => string)
        },
        options?: ExternalToast
    ) => {
        return toast.promise(promise, {
            loading,
            success,
            error,
            ...options,
        })
    }

    const dismiss = (toastId: string | number) => {
        toast.dismiss(toastId)
    }

    return {
        success,
        error,
        info,
        warning,
        promise,
        dismiss,
    }
} 